import RocketsList from '../RocketList';

const Rockets = () => (
  <div style={{ padding: '2rem' }}>
    <RocketsList />
  </div>
);

export default Rockets;
